import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { t } from '../../../../../../../../modules/infra/i18n';
import InfoBlock from '../InfoBlock';
import Money from '../../../../../../../common/money';
import Icon, { GLYPHS } from '../../../../../../../common/icon';
import { getAddressLines } from './utils';

const OrderItem = props => {
  const productColumns = [
    {
      header: t('products:purchase_order.sku_header'),
      cell: item => item.productSku,
    },
    {
      header: t('products:purchase_order.product_name_header'),
      cell: item => item.productName,
    },
    {
      header: t('products:purchase_order.quantity_header'),
      cell: item => item.quantity,
    },
    {
      header: t('products:purchase_order.line_total_header'),
      cell: item => <Money>{item.price * item.quantity}</Money>,
      width: '60px',
    },
  ];

  return (
    <div className="c-vendor-purchase c-inner-wrapper">
    <div className="o-flexbox o-flexbox--content-align-center u-mb+">
      <div>
        <div className="c-form-title u-mb--">
          {props.order.vendorName}
        </div>
        <div className="c-form-subtitle">
          {props.order.vendorEmail}
        </div>
      </div>
      <button
        type="button"
        disabled={!props.canDownloadPdf}
        onClick={props.downloadPdf}
        className="c-btn--blank o-flexbox o-flexbox--content-align-center c-info-tooltip-new-handler"
      >
        <Icon glyph={GLYPHS.download} />
        <div className={cx('u-ml- c-label--section', { 'u-dimmed': !props.canDownloadPdf })}>
          {t('products:purchase_order.save_as_pdf_button')}
        </div>
        <div
          className="c-info-tooltip-new__content"
          display-if={!props.canDownloadPdf}
        >
          {t('products:purchase_order.save_before_pdf_tooltip')}
        </div>
      </button>
    </div>
    <div className="o-flexbox">
      <div className="u-mr" style={{ flex: 1 }}>
        <div className="u-mb">
          <InfoBlock
            columns={[{
              header: t('products:purchase_order.purchase_order_no_header'),
              cell: item => item,
            }]}
            data={[props.order.formattedPoNumber]}
          />
        </div>
        <InfoBlock
          columns={[{
            header: t('products:purchase_order.bill_to_header'),
            cell: item => item,
          }]}
          data={getAddressLines(props.order.billingAddress)}
        />
      </div>
      <div className="extralarge-and-up-mr" style={{ flex: 1 }}>
        <div className="u-mb">
          <InfoBlock
            columns={[{
              header: t('products:purchase_order.date_created_header'),
              cell: item => item,
            }]}
            data={[props.order.formattedDateCreated]}
          />
        </div>
        <InfoBlock
          columns={[{
            header: t('products:purchase_order.ship_to_header'),
            cell: item => item,
          }]}
          data={getAddressLines(props.order.shippingAddress)}
        />
      </div>
      <div className="extralarge-and-down-mt" style={{ flex: 2 }}>
        <div className="u-mb">
          <InfoBlock
            columns={productColumns}
            data={props.order.products}
          />
        </div>
        <InfoBlock
          kind="total"
          columns={[
            {
              header: t('products:purchase_order.total_header'),
              cell: item => item.label,
            },
            {
              width: '100px',
              header: (
                <div className="u-text-right">
                  <Money>{props.order.totalPrice}</Money>
                </div>
              ),
              cell: item => (
                <div className="u-text-right">
                  <Money>{item.value}</Money>
                </div>
              ),
            },
          ]}
          data={[
            {
              label: t('products:purchase_order.subtotal_label'),
              value: props.order.totalPrice,
            },
          ]}
        />
      </div>
    </div>
    </div>
  );
};

OrderItem.propTypes = {
  order: PropTypes.object.isRequired,
  canDownloadPdf: PropTypes.bool.isRequired,
  downloadPdf: PropTypes.func.isRequired,
};

export default OrderItem;
